import { render, staticRenderFns } from "./ImageDragSelector.vue?vue&type=template&id=c024a70e&scoped=true&"
import script from "./ImageDragSelector.vue?vue&type=script&lang=ts&"
export * from "./ImageDragSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ImageDragSelector.vue?vue&type=style&index=0&id=c024a70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c024a70e",
  null
  
)

export default component.exports